<input #fileInput type="file" (click)="$event.target.value=null" (change)="onFilesSelected($event)" [accept]="accept"
	class="input-file" [multiple]="multiple" />

<ion-button [disabled]="disabled" (click)="pickFiles()" class="file-picker-button">
	<ion-icon [slot]="label ? 'start' : 'icon-only'" [name]="iconName"></ion-icon>
	<ion-label *ngIf="label" slot="end">{{label}}</ion-label>
</ion-button>